import React, { useCallback, useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { useLocation, useNavigate } from 'react-router-dom';
import { GlobalUtilContext } from '../contexts';
import { SearchBar } from '../components/SearchBar';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import DynamicDrawer from '../components/Drawer';
import { useTranslation } from 'react-i18next';
import { handleStorageClear } from '../../services/core/auth';

function InAppLayout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { isLoggedIn, selectedService, selectedPartner, selectedDatasourceTab, setIsLoggedIn } =
    useContext(GlobalUtilContext);

  const storageListener = useCallback(() => {
    if (!localStorage.getItem('auth') && location?.pathname !== '/') {
      handleStorageClear();
      setIsLoggedIn(false);
      navigate(`/${localStorage.getItem('service') || ''}`, { replace: true });
    }
  }, [navigate, location, setIsLoggedIn]);

  useEffect(() => {
    window.addEventListener('storage', storageListener);

    return () => {
      window.removeEventListener('storage', storageListener);
    };
  }, [storageListener]);

  return (
    <Box sx={{ display: 'flex', background: '#F1F5F2', maxWidth: '100vw', overflow: 'hidden' }}>
      {isLoggedIn ? <DynamicDrawer /> : null}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          p: 3,
          minHeight: '100%',
          maxWidth: isLoggedIn ? 'calc(100vw - 173px)' : 'unset'
        }}
      >
        {isLoggedIn && selectedService && (
          <>
            <Typography
              sx={{
                fontFamily: 'Mulish',
                fontSize: '20px',
                fontWeight: '600',
                color: '#000000',
                textTransform:
                  selectedService && selectedService?.association_type ? 'capitalize' : 'unset'
              }}
            >
              {`${selectedService ? t(selectedService.association_type) : 'Statistics'} > ${
                selectedPartner ? selectedPartner?.name_or_key : 'Aggregated Stats'
              }`}
            </Typography>
            <SearchBar displaySearch={selectedDatasourceTab?.label === 'drawer.individual_stats'} />
          </>
        )}
        {children}
      </Box>
    </Box>
  );
}

InAppLayout.propTypes = {
  children: PropTypes.any
};

export { InAppLayout };
